import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CustomerOnboardingService } from '../services/customer-onboarding/customer-onboarding.service';
import { ForuscareService } from '../services/foruscare/foruscare.service';

declare var grecaptcha:any;
declare var window:any;

@Component({
  selector: 'app-spectacle-vendor-info',
  templateUrl: './spectacle-vendor-info.component.html',
  styleUrls: ['./spectacle-vendor-info.component.css']
})
export class SpectacleVendorInfoComponent implements OnInit {
  nameExists = false; vendorInfo: any = {
    name: "",
    email: "",
    mobile: "",
    type: "vendor"
  };

  emailExists: boolean = false;
  mobileExists: boolean = false;
  invalidEmailAddress: boolean = false;
  manualCaptcha:boolean = false;

  constructor(private foruscareService: ForuscareService, private router: Router,
    private onboardingService: CustomerOnboardingService) { }

  ngOnInit(): void {
    this.manualCaptcha = false;
  }

  validateVendorName() {
    if (this.vendorInfo.name == null || this.vendorInfo.name.trim().length == 0) {
      this.nameExists = false;
      return;
    }
    this.onboardingService.validateVendorDetails(this.vendorInfo.name, "name")
      .subscribe(response => {
        if (response.status == 204) {
          this.nameExists = false;
        }
        else if (response.status == 409) {
          this.nameExists = true;
        }
      });
  }

  validateVendorEmail() {
    if (this.vendorInfo.email == null || this.vendorInfo.email.trim().length == 0) {
      this.emailExists = false;
      return;
    }
    if (this.validateEmail(this.vendorInfo.email)) {
      this.invalidEmailAddress = false;
    }
    else {
      this.invalidEmailAddress = true;
    }

    this.onboardingService.validateVendorDetails(this.vendorInfo.email, "email")
      .subscribe(response => {
        if (response.status == 204) {
          this.emailExists = false;
        }
        else if (response.status == 409) {
          this.emailExists = true;
        }
      });
  }

  validateVendorMobile() {
    if (this.vendorInfo.mobile == null || this.vendorInfo.mobile.trim().length == 0) {
      this.mobileExists = false;
      return;
    }
    this.onboardingService.validateVendorDetails(this.vendorInfo.mobile, "mobile")
      .subscribe(response => {
        if (response.status == 204) {
          this.mobileExists = false;
        }
        else if (response.status == 409) {
          this.mobileExists = true;
        }
      });
  }

  validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  showManualCaptcha(componentRef:any,vendorInfo:any){
    if(window.recaptchaWidgetId){
      grecaptcha.reset(window.recaptchaWidgetId);
    }
    let captchaElementV2:any = document.getElementById('g-recaptcha-token-v2'); 
    captchaElementV2.style.display = "flex"; 
    componentRef.manualCaptcha = true;

    window.recaptchaWidgetId = grecaptcha.render('g-recaptcha-token-v2', {
      sitekey: componentRef.foruscareService.getCaptchaV2SiteKey(),
      callback: function (token) {
        console.log("CAPTCHA passed! Token:");
        vendorInfo.manualCaptcha = true;
        vendorInfo.captchaToken = token; //replace token by recaptcha v2
        componentRef.onboardingService.inviteServiceProviderWithCaptcha(vendorInfo)
        .subscribe(response => {
          if (response.status == 200 && response.data != null) {
              /*proceed to next steps as captcha is verified */
              componentRef.foruscareService.showNotification("Vendor invited successfully.","success");
              componentRef.router.navigate(['/spectacle/vendors']);
          }
          else{
            componentRef.foruscareService.showNotification("Invalid captcha !", "danger");
          }
        });
      },
      'expired-callback': function () {
        console.warn('reCAPTCHA expired');
      },
      'error-callback': function () {
        console.error('reCAPTCHA error');
      }
    });
  }

  inviteVendor() {
    if (
      (this.vendorInfo.name == null || this.vendorInfo.name.trim().length == 0) ||
      (this.vendorInfo.email == null || this.vendorInfo.email.trim().length == 0) ||
      (this.vendorInfo.mobile == null || this.vendorInfo.mobile.trim().length == 0)) {
      this.foruscareService.showNotification("Please enter mandatory fields to invite vendor", "danger");
      return;
    }

    if (this.emailExists) {
      this.foruscareService.showNotification("Email Address already exists", "danger");
      return;
    }
    if (this.mobileExists) {
      this.foruscareService.showNotification("Mobile Number already exists", "danger");
      return;
    }
    if (this.nameExists) {
      this.foruscareService.showNotification("Vendor Name already exists", "danger");
      return;
    }

    
    if(this.foruscareService.getActiveEnv() == "STGTELEEYE" || this.foruscareService.getActiveEnv() == "LIVE" ){
      let componentRef = this;
      grecaptcha.ready(function () {
        grecaptcha.execute(componentRef.foruscareService.getCaptchaSiteKey(), {action: 'login'}).then(function(token) {
        let captchaElement:any = document.getElementById('g-recaptcha-token'); 
          if(captchaElement!=null){
            captchaElement.value = token;
          }
          if(token){
            componentRef.vendorInfo.captchaToken = token;
            componentRef.vendorInfo.manualCaptcha = false;
            /*first try with automatic capctah */
            componentRef.onboardingService.inviteServiceProviderWithCaptcha(componentRef.vendorInfo)
            .subscribe(response => {
              if (response.status == 200 && response.data != null) {
                  componentRef.foruscareService.showNotification("Vendor invited successfully.", "success");
                  componentRef.router.navigate(['/spectacle/vendors']); 
              }
              else if(response.status == 417){
                /*bot detected. show manual capctha */
                componentRef.showManualCaptcha(componentRef,componentRef.vendorInfo);   
              }
              else {
                componentRef.foruscareService.showNotification(response.message, "danger");
              }
            });
          }
          else{
            componentRef.foruscareService.showNotification("Invalid captcha !","danger");
          }
        });
      });
    }
    else{
      this.onboardingService.inviteServiceProvider(this.vendorInfo)
        .subscribe(response => {
          if (response.status == 200) {
            if (response.data != null) {
              this.foruscareService.showNotification("Vendor invited successfully.",
                "success");
              this.router.navigate(['/spectacle/vendors']);
            }
          }
          else {
            this.foruscareService.showNotification(response.message, "danger");
          }
        });
    }
  }

}
